import React from "react";
import { motion } from "framer-motion";
import nurseImage from "@/assets/testimonial-nurse.webp";
import physicianImage from "@/assets/testimonial-physician.webp";
import seniorImage from "@/assets/testimonial-senior.webp";

const testimonials = [
  {
    image: nurseImage,
    title: "Nurse Practitioner",
    subtitle: "PARTNER ORGANIZATION",
    quote:
      "The use of GrandPads has significantly increased the completion rate of visits. It is so easy, and I can count on the patients being available and completing the visit.",
  },
  {
    image: physicianImage,
    title: "Care Coordinator",
    subtitle: "PARTNER ORGANIZATION",
    quote:
      "I truly believe the GrandPad is an incredible benefit for our members. My goal is to ensure every qualifying member has one by the end of the year...it's clear that the GrandPad helps them combat loneliness and easily connect with family, their doctors, and more.",
  },
  {
    image: seniorImage,
    title: "Senior User",
    subtitle: "PARTNER ORGANIZATION",
    quote:
      "I love it! I'm really impressed and grateful for the concierge app. I've used it a few times already, and it's great knowing my healthcare team is just a tap away!",
  },
];

export function TestimonialsSection() {
  return (
    <section className="w-full bg-background py-20 max-md:py-16" aria-labelledby="testimonials-heading">
      <h2 id="testimonials-heading" className="sr-only">
        Testimonials
      </h2>
      <div className="w-full max-w-[1440px] mx-auto px-4 sm:px-8 md:px-12 lg:px-20 3xl:px-28 4xl:px-32">
        <div className="grid grid-cols-3 gap-8 max-lg:grid-cols-1 max-lg:max-w-md max-lg:mx-auto">
          {testimonials.map((testimonial, index) => (
            <motion.article
              key={index}
              className="relative bg-background rounded-2xl p-8 flex flex-col items-center text-center shadow-[0_8px_32px_0_rgba(31,41,55,0.2)]"
              style={{
                background:
                  "linear-gradient(to bottom, hsl(var(--background)), hsl(var(--background))) padding-box, linear-gradient(to bottom, hsl(var(--fog)), #98AFDB) border-box",
                border: "2px solid transparent",
              }}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, ease: "easeOut", delay: index * 0.15 }}
            >
              <div className="w-40 h-40 rounded-2xl overflow-hidden mb-6">
                <img src={testimonial.image} alt={testimonial.title} className="w-full h-full object-cover" width={384} height={384} loading="lazy" decoding="async" />
              </div>
              <h3 className="text-h4 text-foreground mb-1">{testimonial.title}</h3>
              <span className="text-caption text-beacon uppercase tracking-wider mb-4">{testimonial.subtitle}</span>
              <p className="text-body text-foreground relative z-10">{testimonial.quote}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
